import { Component, input, InputSignal, OnDestroy, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ActivityData, ActivityPanelModes, ActivityService, GraphConfig } from '../activity.service';
import { HighchartsColumnComponent } from './Chart/highchartsColumn.component';
import { ActivityTableComponent } from './Table/activityTable.component';

declare const Highcharts: any;

@Component({
    selector: 'activity-chart',
    templateUrl: 'activityChart.component.html',
    styleUrls: ['activityChart.component.scss'],
    imports: [FormsModule, HighchartsColumnComponent, ActivityTableComponent],
})
export class ActivityChartComponent implements OnInit, OnDestroy {
    constructor(private readonly _activityService: ActivityService) {}

    config: InputSignal<ActivityData> = input(null, { transform: this._updateChart.bind(this) });
    parcelId: InputSignal<number> = input();

    activityMode: string;
    chartType: ActivityPanelModes;
    graphConfig: GraphConfig;
    lastConfig: ActivityData;

    private _destroy$ = new Subject();

    ngOnInit(): void {
        if (!sessionStorage['ws_analysisGraphChartSelection']) {
            this.activityMode = 'graph';
        } else {
            this.activityMode = sessionStorage['ws_analysisGraphChartSelection'];
        }

        this.chartType = ActivityPanelModes.totalFMV;
        this._updateChart(this.config());

        this._activityService.chartTypeChange$.pipe(takeUntil(this._destroy$)).subscribe((x) => {
            this.chartType = x;
            // we have to change our model and redraw chart and table
            // we will not touch this.config (it's shared by other components)
            this._updateChart(this.lastConfig);
        });
    }

    ngOnDestroy(): void {
        this._destroy$.next(true);
        this._destroy$.complete();
    }

    reflowChart(): void {
        Highcharts.fireEvent(window, 'resize');
    }

    activityModeChanged(selection: 'graph' | 'table'): void {
        this.activityMode = selection;
        sessionStorage['ws_analysisGraphChartSelection'] = selection;
    }

    private _updateChart(newValue: ActivityData): ActivityData {
        if (newValue) {
            this.lastConfig = newValue;
            this.graphConfig = this._activityService.createGraphConfig(newValue, this.chartType);
        }
        return newValue;
    }
}
